<div class="th" (dragenter)="onDragEnter($event)" (dragover)="onDragOver($event)" (dragleave)="onDragLeave()" (drop)="onDrop($event)">

  <!-- Fejléc -->
  <header class="th-head">
    <button type="button" class="th-icon th-head__back" (click)="back.emit()" aria-label="Vissza a beszélgetésekhez">
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15,5 8,12 15,19"></polyline></svg>
    </button>
    <span class="av av--md" *ngIf="conversation.type === 'direct'" [style.background]="color(title)">
      <img *ngIf="avatarPath(peer) as p" [src]="p | chatBlob | async" alt="">
      <span>{{ initials(title) }}</span>
      <i class="av__dot" *ngIf="peerOnline"></i>
    </span>
    <span class="av av--md av--group" *ngIf="conversation.type === 'main'">
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="8.5" r="3"></circle><path d="M3.5 19 a5.5 5.5 0 0 1 11 0"></path><circle cx="17" cy="8" r="2.4"></circle><path d="M15 14.5 a5 5 0 0 1 5.5 4.5"></path></svg>
    </span>
    <div class="th-head__text">
      <div class="th-head__title">{{ title }}</div>
      <div class="th-head__sub" [class.th-head__sub--on]="peerOnline">{{ typingLabel || subtitle }}</div>
    </div>
    <button type="button" class="th-icon" (click)="toggleMute()" [title]="conversation.muted ? 'Némítva — kattints a bekapcsoláshoz' : 'Értesítések némítása'" [class.th-icon--muted]="conversation.muted">
      <svg *ngIf="!conversation.muted" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M6 16 V11 a6 6 0 0 1 12 0 v5 l1.5 2 H4.5 Z"></path><path d="M10 20 a2 2 0 0 0 4 0"></path></svg>
      <svg *ngIf="conversation.muted" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M6 16 V11 a6 6 0 0 1 9.5-4.9"></path><path d="M18 11 v5 l1.5 2 H8"></path><path d="M10 20 a2 2 0 0 0 4 0"></path><line x1="3" y1="3" x2="21" y2="21"></line></svg>
    </button>
  </header>

  <!-- Üzenetek -->
  <div class="th-scroll" #scroller (scroll)="onScroll()">
    <div class="th-state" *ngIf="loading">
      <span class="th-spinner"></span>
    </div>
    <div class="th-state" *ngIf="loadError">
      Nem sikerült betölteni. <button type="button" class="th-link" (click)="retryLoad()">Újra</button>
    </div>

    <ng-container *ngIf="!loading && !loadError">
      <div class="th-older" *ngIf="loadingOlder"><span class="th-spinner th-spinner--sm"></span></div>
      <div class="th-intro" *ngIf="!hasMore">
        <span class="av av--xl" *ngIf="conversation.type === 'direct'" [style.background]="color(title)">
          <img *ngIf="avatarPath(peer) as p" [src]="p | chatBlob | async" alt="">
          <span>{{ initials(title) }}</span>
        </span>
        <span class="av av--xl av--group" *ngIf="conversation.type === 'main'">
          <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="8.5" r="3"></circle><path d="M3.5 19 a5.5 5.5 0 0 1 11 0"></path><circle cx="17" cy="8" r="2.4"></circle><path d="M15 14.5 a5 5 0 0 1 5.5 4.5"></path></svg>
        </span>
        <div class="th-intro__title">{{ title }}</div>
        <div class="th-intro__text" *ngIf="conversation.type === 'main'">A csapat közös beszélgetése — mindenki látja, aki a Chatet használja.</div>
        <div class="th-intro__text" *ngIf="conversation.type === 'direct'">Privát beszélgetés — csak ketten látjátok.</div>
      </div>

      <ng-container *ngFor="let row of rows; trackBy: trackRow">
        <div class="th-day" *ngIf="row.kind === 'day'"><span>{{ row.label }}</span></div>
        <div class="th-time" *ngIf="row.kind === 'time'">{{ row.label }}</div>

        <div *ngIf="row.kind === 'msg' && row.msg as msg"
             class="msg"
             [attr.data-mid]="msg.id"
             [class.msg--mine]="row.mine"
             [class.msg--first]="row.first"
             [class.msg--last]="row.last"
             [class.msg--hl]="highlight === msg.id"
             [class.msg--menu]="pickerFor === msg.id || moreFor === msg.id"
             [class.msg--local]="!!msg.local"
             [class.msg--failed]="msg.local?.status === 'failed'">

          <div class="msg__name" *ngIf="row.showName">{{ nameOf(msg.authorId) }}</div>

          <!-- idézett üzenet -->
          <button type="button" class="msg__reply" *ngIf="msg.replyTo as rt" (click)="jumpTo(rt.id)">
            <span class="msg__reply-who">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9,14 4,9 9,4"></polyline><path d="M20 20 v-7 a4 4 0 0 0 -4 -4 H4"></path></svg>
              {{ replyLabel(msg) }}
            </span>
            <span class="msg__reply-text">
              <ng-container *ngIf="rt.deleted">Törölt üzenet</ng-container>
              <ng-container *ngIf="!rt.deleted">{{ rt.text || (rt.attachments ? '📎 Csatolmány' : rt.refs ? '🔗 Hivatkozás' : '') }}</ng-container>
            </span>
          </button>

          <div class="msg__line">
            <span class="msg__av" *ngIf="!row.mine">
              <span class="av av--sm" *ngIf="row.last" [style.background]="color(nameOf(msg.authorId))" [title]="nameOf(msg.authorId)">
                <img *ngIf="avatarPath(member(msg.authorId)) as p" [src]="p | chatBlob | async" alt="">
                <span>{{ initials(nameOf(msg.authorId)) }}</span>
              </span>
            </span>

            <div class="msg__stack"
                 (touchstart)="onTouchStart(msg)" (touchend)="cancelLongPress()" (touchmove)="cancelLongPress()" (touchcancel)="cancelLongPress()"
                 (contextmenu)="isTouch && $event.preventDefault()">

              <!-- törölt -->
              <div class="bubble bubble--deleted" *ngIf="msg.deleted" [title]="fullTime(msg.createdAt)">Az üzenetet törölték</div>

              <ng-container *ngIf="!msg.deleted">
                <!-- képek -->
                <div class="msg__images" *ngIf="row.images?.length" [class.msg__images--grid]="(row.images?.length || 0) > 1">
                  <button type="button" class="msg__img" *ngFor="let img of row.images; let i = index"
                          [style.aspect-ratio]="(row.images?.length || 0) > 1 ? '1 / 1' : imageRatio(img)"
                          (click)="openImage(row, i)" [title]="img.name">
                    <img *ngIf="msg.local" [src]="localPreview(msg, img)" alt="">
                    <img *ngIf="!msg.local" [src]="thumbPath(img) | chatBlob | async" [alt]="img.name" loading="lazy">
                  </button>
                </div>

                <!-- fájlok -->
                <button type="button" class="msg__file" *ngFor="let f of row.files" [class.msg__file--3d]="isModel(f)" (click)="!msg.local && openFile(f)" [title]="(isModel(f) ? 'Megnézem 3D-ben: ' : 'Letöltés: ') + f.name">
                  <span class="msg__file-ext">{{ isModel(f) ? '3D' : fileExt(f.name) }}</span>
                  <span class="msg__file-text">
                    <span class="msg__file-name">{{ f.name }}</span>
                    <span class="msg__file-size">{{ fileSize(f.size) }}</span>
                  </span>
                  <svg class="msg__file-dl" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 4 v11"></path><polyline points="7,10 12,15 17,10"></polyline><path d="M5 19 h14"></path></svg>
                </button>

                <!-- hivatkozások -->
                <button type="button" class="ref" *ngFor="let card of msg.refs" [class.ref--off]="card.restricted || card.missing"
                        (click)="openRef(card)" [attr.data-type]="card.type">
                  <span class="ref__icon" [ngSwitch]="card.type">
                    <svg *ngSwitchCase="'order'" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><polyline points="3,4 6,4 8.4,14.5 18.6,14.5 20.6,7.5 7.2,7.5"></polyline><circle cx="9.4" cy="19" r="1.5"></circle><circle cx="17.4" cy="19" r="1.5"></circle></svg>
                    <svg *ngSwitchCase="'po'" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M4 8 l8 -4 l8 4 v8 l-8 4 l-8 -4 Z"></path><polyline points="4,8 12,12 20,8"></polyline><line x1="12" y1="12" x2="12" y2="20"></line></svg>
                    <svg *ngSwitchCase="'ticket'" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="4" width="16" height="16" rx="3"></rect><polyline points="8.5,12 11,14.5 15.5,9.5"></polyline></svg>
                    <svg *ngSwitchDefault width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="5" width="18" height="14" rx="2.5"></rect><polyline points="3.5,7 12,13 20.5,7"></polyline></svg>
                  </span>
                  <span class="ref__body">
                    <span class="ref__title">{{ card.title }}</span>
                    <span class="ref__sub" *ngIf="card.subtitle">{{ card.subtitle }}</span>
                    <span class="ref__meta" *ngIf="card.meta || card.status">
                      <span class="ref__status" *ngIf="card.status">{{ card.status }}</span>{{ card.meta }}
                    </span>
                  </span>
                  <svg *ngIf="!card.restricted && !card.missing" class="ref__go" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9,5 16,12 9,19"></polyline></svg>
                </button>
                <ng-container *ngFor="let card of msg.refs">
                  <button type="button" class="ref-action" *ngIf="card.action && !card.restricted && canApprove" (click)="runCardAction(card)" [disabled]="cardBusy[card.type + card.id]">
                    {{ cardBusy[card.type + card.id] ? '…' : card.action.label }} · {{ card.title.split(' · ')[0] }}
                  </button>
                </ng-container>

                <!-- szöveg -->
                <div class="bubble" *ngIf="msg.text && !row.emojiOnly" [title]="fullTime(msg.createdAt)"
                     (click)="onTextClick($event); isTouch && toggleTime(msg)" [innerHTML]="row.html"></div>
                <div class="bubble bubble--emoji" *ngIf="row.emojiOnly" [title]="fullTime(msg.createdAt)" (click)="isTouch && toggleTime(msg)">{{ msg.text }}</div>
              </ng-container>

              <!-- reakciók -->
              <button type="button" class="msg__reacts" *ngIf="msg.reactions.length" [class.msg__reacts--mine]="reactionSummary(msg).mine" (click)="openInfo(msg)" title="Ki reagált">
                <span *ngFor="let e of reactionSummary(msg).emojis">{{ e }}</span>
                <b *ngIf="reactionSummary(msg).count > 1">{{ reactionSummary(msg).count }}</b>
              </button>
            </div>

            <!-- asztali eszköztár (hover) -->
            <div class="msg__tools" *ngIf="!msg.local && !msg.deleted && !isTouch">
              <button type="button" class="th-icon th-icon--sm" (click)="togglePicker(msg, $event)" title="Reakció">
                <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"></circle><path d="M8.5 14.5 a4.5 4.5 0 0 0 7 0"></path><circle cx="9" cy="10" r="0.8" fill="currentColor"></circle><circle cx="15" cy="10" r="0.8" fill="currentColor"></circle></svg>
              </button>
              <button type="button" class="th-icon th-icon--sm" (click)="startReply(msg)" title="Válasz">
                <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><polyline points="9,14 4,9 9,4"></polyline><path d="M20 20 v-7 a4 4 0 0 0 -4 -4 H4"></path></svg>
              </button>
              <button type="button" class="th-icon th-icon--sm" (click)="toggleMore(msg, $event)" title="Továbbiak">
                <svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor"><circle cx="5" cy="12" r="1.8"></circle><circle cx="12" cy="12" r="1.8"></circle><circle cx="19" cy="12" r="1.8"></circle></svg>
              </button>

              <div class="pop pop--react" *ngIf="pickerFor === msg.id" [class.pop--down]="menuDown" (click)="$event.stopPropagation()">
                <button type="button" *ngFor="let e of reactions" [class.on]="myReaction(msg) === e" (click)="react(msg, e)">{{ e }}</button>
              </div>
              <div class="pop pop--menu" *ngIf="moreFor === msg.id" [class.pop--down]="menuDown" (click)="$event.stopPropagation()">
                <button type="button" *ngIf="canEdit(msg)" (click)="startEdit(msg)">Szerkesztés</button>
                <button type="button" *ngIf="msg.text" (click)="copyText(msg)">Szöveg másolása</button>
                <button type="button" (click)="openInfo(msg)">Ki látta?</button>
                <button type="button" class="danger" *ngIf="canDelete(msg)" (click)="deleteMessage(msg)">Törlés</button>
              </div>
            </div>
          </div>

          <!-- állapot / idő a csoport alatt -->
          <div class="msg__meta" *ngIf="msg.local">
            <ng-container *ngIf="msg.local.status === 'sending'">
              <span *ngIf="msg.local.files.length && msg.local.progress < 100" class="msg__progress"><i [style.width.%]="msg.local.progress"></i></span>
              Küldés…
            </ng-container>
            <ng-container *ngIf="msg.local.status === 'failed'">
              <span class="msg__err">Nem ment el.</span>
              <button type="button" class="th-link" (click)="retry(msg)">Újra</button> ·
              <button type="button" class="th-link" (click)="discard(msg)">Elvetés</button>
            </ng-container>
          </div>
          <div class="msg__meta" *ngIf="!msg.local && (row.last || selectedTimeFor === msg.id || row.readers?.length || row.sent)">
            <span *ngIf="row.last || selectedTimeFor === msg.id" [title]="fullTime(msg.createdAt)">{{ clock(msg.createdAt) }}<ng-container *ngIf="msg.editedAt && !msg.deleted"> · szerkesztve</ng-container></span>
            <span *ngIf="row.sent && !row.readers?.length" class="msg__sent">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><polyline points="5,12.5 10,17.5 19,7"></polyline></svg>
              Elküldve
            </span>
            <span class="msg__readers" *ngIf="row.readers?.length" (click)="openInfo(msg)" title="Ki látta?">
              <span class="av av--xs" *ngFor="let r of row.readers | slice:0:6" [style.background]="color(r.name)" [title]="'Látta: ' + r.name">
                <img *ngIf="avatarPath(r) as p" [src]="p | chatBlob | async" alt="">
                <span>{{ initials(r.name) }}</span>
              </span>
              <b *ngIf="(row.readers?.length || 0) > 6">+{{ (row.readers?.length || 0) - 6 }}</b>
            </span>
          </div>
        </div>
      </ng-container>

      <!-- gépel… -->
      <div class="msg msg--first msg--last th-typing" *ngIf="typingUsers.length">
        <div class="msg__line">
          <span class="msg__av">
            <span class="av av--sm" [style.background]="color(nameOf(typingUsers[0]))">
              <img *ngIf="avatarPath(member(typingUsers[0])) as p" [src]="p | chatBlob | async" alt="">
              <span>{{ initials(nameOf(typingUsers[0])) }}</span>
            </span>
          </span>
          <div class="bubble bubble--typing" [title]="typingLabel"><i></i><i></i><i></i></div>
        </div>
      </div>
    </ng-container>
  </div>

  <button type="button" class="th-newbelow" *ngIf="newBelow > 0 || !atBottom" (click)="scrollToBottom()">
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="5,9 12,16 19,9"></polyline></svg>
    <span *ngIf="newBelow > 0">{{ newBelow }} új üzenet</span>
  </button>

  <!-- Üzenetíró -->
  <footer class="cmp">
    <div class="cmp__banner" *ngIf="replyTo as rt">
      <div class="cmp__banner-text">
        <b>Válasz {{ rt.authorId === me ? 'a saját üzenetedre' : firstNameOf(rt.authorId) + ' üzenetére' }}</b>
        <span>{{ rt.deleted ? 'Törölt üzenet' : rt.text || (rt.attachments.length ? '📎 Csatolmány' : '🔗 Hivatkozás') }}</span>
      </div>
      <button type="button" class="th-icon th-icon--sm" (click)="replyTo = null" aria-label="Válasz elvetése">✕</button>
    </div>
    <div class="cmp__banner cmp__banner--edit" *ngIf="editing">
      <div class="cmp__banner-text">
        <b>Üzenet szerkesztése</b>
        <span>{{ isTouch ? 'Mentés a pipával' : 'Enter: mentés · Esc: mégse' }}</span>
      </div>
      <button type="button" class="th-icon th-icon--sm" (click)="cancelEdit()" aria-label="Szerkesztés elvetése">✕</button>
    </div>

    <div class="cmp__pending" *ngIf="pendingFiles.length || pendingRefs.length">
      <div class="cmp__chip cmp__chip--img" *ngFor="let p of pendingFiles" [class.cmp__chip--file]="!p.preview" [title]="p.file.name">
        <img *ngIf="p.preview" [src]="p.preview" alt="">
        <ng-container *ngIf="!p.preview">
          <span class="msg__file-ext">{{ fileExt(p.file.name) }}</span>
          <span class="cmp__chip-name">{{ p.file.name }}</span>
        </ng-container>
        <button type="button" (click)="removeFile(p)" aria-label="Eltávolítás">✕</button>
      </div>
      <div class="cmp__chip cmp__chip--ref" *ngFor="let r of pendingRefs" [attr.data-type]="r.type">
        <span class="cmp__chip-name">🔗 {{ r.title }}</span>
        <button type="button" (click)="removeRef(r)" aria-label="Eltávolítás">✕</button>
      </div>
    </div>

    <div class="cmp__row">
      <div class="cmp__attach" (click)="$event.stopPropagation()">
        <button type="button" class="th-icon cmp__plus" [class.on]="attachMenu" (click)="attachMenu = !attachMenu; pickerFor = null; moreFor = null" aria-label="Csatolás" title="Csatolás">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
        </button>
        <div class="pop pop--attach" *ngIf="attachMenu">
          <button type="button" (click)="openFilePicker('image/*')">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="16" rx="2.5"></rect><circle cx="8.5" cy="9.5" r="1.8"></circle><polyline points="21,16 15.5,10.5 5,20"></polyline></svg>
            Kép / fotó
          </button>
          <button type="button" (click)="openFilePicker('')">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M20.5 11.5 L12 20 a5 5 0 0 1 -7 -7 l8.5 -8.5 a3.3 3.3 0 0 1 4.7 4.7 L9.7 17.7 a1.7 1.7 0 0 1 -2.4 -2.4 L15 7.6"></path></svg>
            Fájl
          </button>
          <button type="button" (click)="openRefPicker()">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M10 14 a4 4 0 0 0 5.7 0 l3 -3 a4 4 0 0 0 -5.7 -5.7 l-1 1"></path><path d="M14 10 a4 4 0 0 0 -5.7 0 l-3 3 a4 4 0 0 0 5.7 5.7 l1 -1"></path></svg>
            Rendelés, task, levél
          </button>
        </div>
      </div>
      <input #fileInput type="file" multiple hidden (change)="onFilesChosen($event)">

      <textarea #input class="cmp__input" rows="1" [(ngModel)]="text" (input)="onInput()" (keydown)="onKeydown($event)" (paste)="onPaste($event)"
                [placeholder]="editing ? 'Üzenet szerkesztése…' : 'Üzenet írása…'" maxlength="5000" enterkeyhint="enter"></textarea>

      <button type="button" class="cmp__send" *ngIf="canSend || editing" (click)="submit()" [attr.aria-label]="editing ? 'Mentés' : 'Küldés'" [title]="editing ? 'Mentés' : 'Küldés'">
        <svg *ngIf="!editing" width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M3.4 20.4 21 12 3.4 3.6 3.4 10.2 15 12 3.4 13.8z"></path></svg>
        <svg *ngIf="editing" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><polyline points="5,12.5 10,17.5 19,7"></polyline></svg>
      </button>
      <button type="button" class="cmp__like" *ngIf="!canSend && !editing" (click)="sendLike()" title="Like küldése" aria-label="Like küldése">👍</button>
    </div>
  </footer>

  <div class="th-drop" *ngIf="dragOver">
    <div>
      <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M12 16 V4"></path><polyline points="7,9 12,4 17,9"></polyline><path d="M4 16 v3 a1 1 0 0 0 1 1 h14 a1 1 0 0 0 1 -1 v-3"></path></svg>
      Engedd el a csatoláshoz
    </div>
  </div>
</div>

<!-- Érintés: hosszú nyomás → alsó lap -->
<div class="sheet-bg" *ngIf="sheet" (click)="sheet = null">
  <div class="sheet" (click)="$event.stopPropagation()">
    <div class="sheet__reacts">
      <button type="button" *ngFor="let e of reactions" [class.on]="myReaction(sheet) === e" (click)="react(sheet, e)">{{ e }}</button>
    </div>
    <button type="button" class="sheet__item" (click)="startReply(sheet)">Válasz</button>
    <button type="button" class="sheet__item" *ngIf="sheet.text" (click)="copyText(sheet)">Szöveg másolása</button>
    <button type="button" class="sheet__item" *ngIf="canEdit(sheet)" (click)="startEdit(sheet)">Szerkesztés</button>
    <button type="button" class="sheet__item" (click)="openInfo(sheet)">Ki látta? · {{ fullTime(sheet.createdAt) }}</button>
    <button type="button" class="sheet__item sheet__item--danger" *ngIf="canDelete(sheet)" (click)="deleteMessage(sheet)">Törlés</button>
    <button type="button" class="sheet__item sheet__item--cancel" (click)="sheet = null">Mégse</button>
  </div>
</div>

<!-- Üzenet adatai: reakciók + ki látta -->
<div class="sheet-bg sheet-bg--center" *ngIf="info" (click)="info = null">
  <div class="info" (click)="$event.stopPropagation()">
    <header class="info__head">
      <b>Üzenet adatai</b>
      <button type="button" class="th-icon th-icon--sm" (click)="info = null" aria-label="Bezárás">✕</button>
    </header>
    <div class="info__meta">{{ nameOf(info.msg.authorId) }} · {{ fullTime(info.msg.createdAt) }}<ng-container *ngIf="info.msg.editedAt"> · szerkesztve {{ clock(info.msg.editedAt) }}</ng-container></div>

    <ng-container *ngIf="info.reactionList.length">
      <div class="info__label">Reakciók</div>
      <div class="info__row" *ngFor="let r of info.reactionList">
        <span class="av av--sm" [style.background]="color(r.member?.name || '?')">
          <img *ngIf="avatarPath(r.member) as p" [src]="p | chatBlob | async" alt="">
          <span>{{ initials(r.member?.name || '?') }}</span>
        </span>
        <span class="info__name">{{ nameOf(r.id) }}</span>
        <button type="button" class="info__emoji" *ngIf="r.id === me" (click)="react(info.msg, r.emoji)" title="Visszavonás">{{ r.emoji }} <small>visszavon</small></button>
        <span class="info__emoji" *ngIf="r.id !== me">{{ r.emoji }}</span>
      </div>
    </ng-container>

    <div class="info__label">Látta</div>
    <div class="th-state th-state--sm" *ngIf="!info.seen"><span class="th-spinner th-spinner--sm"></span></div>
    <div class="info__empty" *ngIf="info.seen && !info.seenList.length">Még senki.</div>
    <div class="info__row" *ngFor="let s of info.seenList">
      <span class="av av--sm" [style.background]="color(s.member.name)">
        <img *ngIf="avatarPath(s.member) as p" [src]="p | chatBlob | async" alt="">
        <span>{{ initials(s.member.name) }}</span>
      </span>
      <span class="info__name">{{ s.member.name }}</span>
      <span class="info__when">{{ fullTime(s.seenAt) }}</span>
    </div>
    <ng-container *ngIf="info.unseenList.length">
      <div class="info__label">Még nem látta</div>
      <div class="info__row info__row--dim" *ngFor="let s of info.unseenList">
        <span class="av av--sm" [style.background]="color(s.member.name)">
          <img *ngIf="avatarPath(s.member) as p" [src]="p | chatBlob | async" alt="">
          <span>{{ initials(s.member.name) }}</span>
        </span>
        <span class="info__name">{{ s.member.name }}</span>
      </div>
    </ng-container>
  </div>
</div>

<!-- Képnézegető -->
<div class="lb" *ngIf="lightbox as lb" (click)="lightbox = null">
  <div class="lb__bar" (click)="$event.stopPropagation()">
    <span class="lb__name">{{ lb.images[lb.index].name }}<small *ngIf="lb.images.length > 1"> · {{ lb.index + 1 }}/{{ lb.images.length }}</small></span>
    <button type="button" class="th-icon th-icon--light" (click)="download(lb.images[lb.index])" title="Letöltés" aria-label="Letöltés">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 4 v11"></path><polyline points="7,10 12,15 17,10"></polyline><path d="M5 19 h14"></path></svg>
    </button>
    <button type="button" class="th-icon th-icon--light" (click)="lightbox = null" aria-label="Bezárás">✕</button>
  </div>
  <img class="lb__img" [src]="originalPath(lb.images[lb.index]) | chatBlob | async" [alt]="lb.images[lb.index].name" (click)="$event.stopPropagation()">
  <ng-container *ngIf="lb.images.length > 1">
    <button type="button" class="lb__nav lb__nav--prev" (click)="$event.stopPropagation(); lightboxStep(-1)" aria-label="Előző">‹</button>
    <button type="button" class="lb__nav lb__nav--next" (click)="$event.stopPropagation(); lightboxStep(1)" aria-label="Következő">›</button>
  </ng-container>
</div>

<!-- 3D-nézegető (STL / 3MF / OBJ) -->
<app-chat-model-viewer *ngIf="modelView" [attachment]="modelView" (close)="modelView = null" (download)="download($event)"></app-chat-model-viewer>

<app-chat-ref-picker *ngIf="refPicker" (pick)="addRef($event)" (close)="refPicker = false"></app-chat-ref-picker>
